export function getColor(defaultColor: string = "0, 0, 0, 1", color: string, blackColor: boolean): string {
  if (blackColor) {
    return "rgba(0, 0, 0, 1)"; // blackColor prop
  }
  return color ? `rgba(${color})` : `rgba(${defaultColor})`;
}
